<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true" 
            [DateInit]="nominasEspeciales?.fecha" 
            [DateEnd]="nominasEspeciales?.fecha"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="nominaEspecialHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [enableCut]=false
            [CurrentPeriod]="nominasEspeciales?.id">
</iboxtools>

<app-nominas-especiales-list *ngIf="!verDetalle && !buscando" [personalId]="personalId" 
                                                         [nominasEspeciales]="nominasEspeciales" 
                                                         [permisoEdicion]="permisoEdicion"
                                                         (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-nominas-especiales-list>

<app-nominas-especiales-detalle #ChildNominaEspecialDetalle [nominaEspecial]="nominaEspecial" *ngIf="verDetalle" 
                          [enabledForm]="habilitarFormDetalle" 
                          [MensajeError]="MensajeError" 
                          [desdeAnterior]="desdeAnterior" 
                          [ingreso]="ingreso" 
                          [anteriorRetroactividad]="anteriorRetroactividad" 
                          [grupoLiq]="gruposLiquidaciones" 
                          [nominasInvalida]="nominasInvalida">
</app-nominas-especiales-detalle>

